import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import {
  BottomNavigationAction,
  BottomNavigation as BottomNavigationWrapper,
  Paper,
  useMediaQuery,
} from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLocalStorageSimple } from '../../../hooks/useLocalStorage'; 


import { Auth } from '../../../Modules/Auth';
import { useAppDispatch } from '../../../hooks/redux';
import { useActions } from '../../../hooks/useActions';
import { useBasket } from '../../../hooks/useBasket';
import { useLayout } from '../../../hooks/useLayout';
import { useSearch } from '../../../hooks/useSearch';
import { useUser } from '../../../hooks/useUser';
import { Icon } from '../../Icon';

import './BottomNavigation.sass';

//Навигация на моб. версии
export const BottomNavigation = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { setNavigationPath, setVisibleHistory, setVisibleDrawerDialog } =
    useActions();
  const { navigationPath } = useLayout();
  const { value, showMenu, visibleHistory } = useSearch();
  const { order_quantity } = useBasket();
  const { visibleDrawerDialog, loggedIn } = useUser();
  // Добавить/Получить токен
  const [sessionToken, setSessionToken] = useLocalStorageSimple('st', '');

  // Меняем активный таб
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setNavigationPath(newValue);
  };
  // Открываем окно авторизации
  const onOpenAuthDialog = async () => {
    // Если не авторизован, то открываем окно авторизации
    if (!loggedIn) {
      setVisibleDrawerDialog(!visibleDrawerDialog);
    } else {
      // Если авторизован, то открываем выходим
      if (window.confirm('Вы действительно хотите выйти ?')) {
        await Auth.Logout(
          dispatch,
          sessionToken,
          setSessionToken
        );
      }
    }
  };
  // Открываем окно поиска
  const onOpenSearch = () => {
    // Если пользватель находится внизу, то при фокусе на инпут, плавно происходит скролл на вверх
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Открываем/Закрываем историю поиска
    setVisibleHistory(!visibleHistory);
    document.body.style.overflow =
      !showMenu && !visibleHistory ? 'hidden' : 'visible';
  };

  return (
    /*    <div
      className={classNames('bottom-navigation', {
        ['review']: visibleInnerReview,
        ['auth_dialog']: visibleDrawerDialog,
      })}
    >
      {BottomNavigationData.items.map((item, index) => {
        return (
          <div
            onClick={() => handleNavigationActive(item)}
            className={navigationActive === index + 1 ? 'bottom-navigation__list active' : 'bottom-navigation__list'}
          >
            <Icon variant={item.icon} />
            {item.id == 4 && order_quantity !== 0 && (
              <div className="bottom-navigation__list__basket_quantity">
                <span>{order_quantity}</span>
              </div>
            )}
          </div>
        );
      })}
    </div>*/
    <Paper
      sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1111 }}
      elevation={3}
    >
      <BottomNavigationWrapper value={navigationPath} onChange={handleChange}>
        <BottomNavigationAction
          sx={{ minWidth: '40px' }}
          value="home"
          icon={
            <Link
              to="/"
              className={
                navigationPath === 'home'
                  ? 'bottom-navigation__list active'
                  : 'bottom-navigation__list'
              }
            >
              <Icon variant="homeMenu" />
            </Link>
          }
        />
        <BottomNavigationAction
          sx={{ minWidth: '40px' }}
          value={
            !visibleHistory
              ? 'search'
              : location.pathname === '/'
              ? 'home'
              : location.pathname === '/basket'
              ? 'basket'
              : 'search'
          }
          onClick={onOpenSearch}
          icon={
            <div
              className={
                navigationPath === 'search'
                  ? 'bottom-navigation__list active'
                  : 'bottom-navigation__list'
              }
            >
              <Icon variant="catalogMenu" />
            </div>
          }
        />
        <BottomNavigationAction
          sx={{ minWidth: '40px' }}
          value={navigationPath}
          icon={
            <div
              className={
                navigationPath === 'order'
                  ? 'bottom-navigation__list active'
                  : 'bottom-navigation__list'
              }
            >
              <Icon variant="orderMenu" />
            </div>
          }
        />
        <BottomNavigationAction
          sx={{ minWidth: '40px' }}
          value="basket"
          icon={
            <Link
              to="/basket"
              className={
                navigationPath === 'basket'
                  ? 'bottom-navigation__list active'
                  : 'bottom-navigation__list'
              }
            >
              <Icon variant="basketMenu" />
              {order_quantity !== 0 && (
                <div className="bottom-navigation__list__basket_quantity">
                  <span>{order_quantity}</span>
                </div>
              )}
            </Link>
          }
        />
        <BottomNavigationAction
          sx={{ minWidth: '40px' }}
          value={navigationPath}
          onClick={onOpenAuthDialog}
          icon={
            <div
              className={
                navigationPath === 'entry'
                  ? 'bottom-navigation__list active'
                  : 'bottom-navigation__list'
              }
            >
              {!loggedIn ? <Icon variant="entryMenu" /> : <LogoutRoundedIcon />}
            </div>
          }
        />
      </BottomNavigationWrapper>
    </Paper>
  );
};
